module.exports = __webpack_public_path__ + "4e85bc9ebe07e0340c9c4fc2f6c38908.ttf";